module.exports = __webpack_public_path__ + "pinterest-icon-small-3562bf24ce15d6bbf017c80f7d677550.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/social-medias/pinterest-icon-small.svg
// module id = 95
// module chunks = 0